import React, {ButtonHTMLAttributes, FC} from 'react';
import {Button} from "@src/@/components/ui/button";


type Props = ButtonHTMLAttributes<HTMLButtonElement>
const NegativeButton: FC<Props> = (props) => <Button variant={'negative'} {...props} />

export default NegativeButton;
